import { RefObject, useEffect } from 'react';
import { zoomLevelStore } from '../store/zoomLevel';

export const useZoomLevelCssVariable = ({
  newTimelineContainerRef
}: {
  newTimelineContainerRef: RefObject<HTMLDivElement>;
}) => {
  useEffect(() => {
    const handleZoomLevelChange = () => {
      if (newTimelineContainerRef.current) {
        const { zoomLevel } = zoomLevelStore.getSnapshot();
        newTimelineContainerRef.current.style.setProperty('--timeline-zoom', `${zoomLevel}`);
      }
    };

    handleZoomLevelChange();
    const zoomLevel = zoomLevelStore.getSnapshot().zoomLevel;
    if (newTimelineContainerRef.current) {
      newTimelineContainerRef.current.style.setProperty('--timeline-zoom', `${zoomLevel}`);
    }
    const unsubscribe = zoomLevelStore.subscribe(handleZoomLevelChange);
    return () => {
      unsubscribe();
    };
  }, [newTimelineContainerRef]);
};
